import { useQuery } from '@tanstack/react-query';
import { conversationClient } from '@/lib/gupshup-client';

interface UseHandoffCountOptions {
    enabled: boolean;
    interval?: number;
}

export function useHandoffCount({ enabled, interval = 15000 }: UseHandoffCountOptions) {
    // On error React Query keeps the last data, so transient failures don't
    // reset the badge (same behavior as the old polling hook).
    const { data } = useQuery({
        queryKey: ['handoff-count'],
        queryFn: async () => {
            const response = await conversationClient.conversations.getHandoffCount();
            return response.count;
        },
        enabled,
        refetchInterval: interval,
    });

    return { handoffCount: data ?? 0 };
}
